const _ = require('underscore');
const { ACTIVE, DONE, DELETED, FUTURE } = require('types/AssignmentStatus');

const { CHANGE, CHANGE_DEADLINE, SHOW_RESULTS, DELETE, CLOSE } = require('types/AssignmentActions');

const OPTIONS_MAP = require('types/AssignmentOptions');

class ReadWorksAssignment {
	constructor(assignment) {
		for (var key in assignment) {
			this[key] = assignment[key];
		}
		this.productMetaData = this.productMetaData || this.product;
		this.status = this.getStatus();
		this.actions = this.getActions();
		this.options = this.mapOptions(this.options);
	}
	getStatus() {
		if (this.assignmentStatus === DELETED) {
			return DELETED;
		} else if (this.isCurrentAssignment()) {
			return ACTIVE;
		} else if (this.isFutureAssignment()) {
			return FUTURE;
		} else if (this.isPastAssignment()) {
			return DONE;
		}
		return null;
	}
	mapOptions(options) {
		return _.assign(
			{},
			options,
			Object.keys(options).reduce((acc, k) => {
				if (OPTIONS_MAP[k]) {
					acc[OPTIONS_MAP[k]] = options[k];
				}
				return acc;
			}, {})
		);
	}
	isFutureAssignment() {
		let now = new Date().getTime() / 1000;

		//	Future if start date has not passed
		if (this.startDate && this.startDate > now) {
			return true;
		}
		return false;
	}
	isCurrentAssignment() {
		let now = new Date().getTime() / 1000;

		//	Current if start date has passed,
		//		has not been moved to Past,
		//		and if  it has a deadline, deadline has not passed
		if (this.startDate && this.startDate < now && this.assignmentStatus !== 'i' && ((this.deadline && this.deadline > now) || !this.deadline)) {
			return true;
		}
		return false;
	}
	isPastAssignment() {
		let now = new Date().getTime() / 1000;

		// Past if deadline has passed
		//		or has been specifically moved to Past
		if ((this.deadline && this.deadline < now) || (!this.deadline && this.assignmentStatus === 'i')) {
			return true;
		}
		return false;
	}
	hasQuestionSets() {
		if (this.productMetaData && this.productMetaData.questionSets && this.options && this.options.questionSets) {
			let questionSets = this.productMetaData.questionSets;
			let assignedSets = this.options.questionSets;
			return assignedSets.some(qs => !questionSets[qs].vocabularyWord);
		}
		return false;
	}
	hasVocabSupport() {
		let options = this.options;
		let hasSupports = options && options.assignVocabulary && (typeof options.assignVocabulary === 'boolean' || options.assignVocabulary.length);
		return hasSupports;
	}
	hasVocabActivity() {
		return this.options && this.options.vocabularyActivities && this.options.vocabularyActivities.length > 0;
	}
	getActions() {
		let status = this.status;
		let productType = this.productMetaData.productType;
		let options = [];

		if (status === FUTURE) {
			options.push({
				value: CHANGE,
				text: 'Change Assignment'
			});
		}

		if (this.deadline && (status === ACTIVE || status === DONE)) {
			let changeText = status === ACTIVE ? 'Change ' : 'Extend ';
			changeText += productType === 'AAD' ? 'End Date' : 'Due Date';

			options.push({
				value: CHANGE_DEADLINE,
				text: changeText
			});
		}

		if (productType !== 'AAD') {
			if (status === DONE && !this.closed) {
				options.push({
					value: CLOSE,
					text: 'End Assignment'
				});
			}

			let text = 'Hide results from students';
			if (this.showResults === false) {
				text = 'Share results with students';
			}
			options.push({
				value: SHOW_RESULTS,
				text
			});
		}

		options.push({
			value: DELETE,
			text: 'Delete'
		});

		return options;
	}
}

module.exports = ReadWorksAssignment;
